class MemberActions {
  constructor() {
    this.generateActions('login', 'logout');
  }

}

export default MemberActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Member.js